// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import Image from 'next/image'
import { partners } from './partners'
import useMedia from 'hooks/use-media';


SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const SectionPartner = () => {
    const isSm = useMedia(`(max-width: 480px)`) 
    const isMd = useMedia(`(max-width: 768px)`)
    let spaceBetween = 50
    if (isSm) {
        spaceBetween = 60
    } else if (isMd) {
        spaceBetween = 100
    }
    return (
        <Swiper
            autoplay={{ delay: 3000 }}
            spaceBetween={spaceBetween}
            breakpoints={{
                // when window width is >= 640px
                320: {
                    width: 260,
                    slidesPerView: 2,
                },
                480: {
                    width: 320,
                    slidesPerView: 2,
                },
                // when window width is >= 768px
                768: {
                    width: 768,
                    slidesPerView: 4,
                },
                1024: {
                    width: 1024,
                    slidesPerView: 5,
                },
            }}
            pagination={{ clickable: true }}
        >
            {partners.map((partner, i) => (
                <SwiperSlide key={i}>
                    <Image 
                        src={partner.src}
                        alt={`partner-${i}`}
                        width={partner.width}
                        height={partner.height}
                        objectFit="contain"
                        quality={100}
                        loading="lazy"
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default SectionPartner
